import React, { useEffect, useState } from "react";
import MaterialTable from "material-table";

// components
import {
  Card,
  CardHeader,
  Container,
  Row,
  Col,
  Button,
  CardBody
} from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import Header from "../../../components/Headers/Header.jsx";

// services
import { showMessage } from "../../../services/message.js";
import { api_GET } from "../../../services/api_service.js";

//Constants
import { table_style, table_translate } from "../../../constants/MaterialTable.js";
import IndiceQualidadeForm from "./IndiceQualidadeForm.jsx";


export default function IndiceQualidadeList({ history }) {
  const [list_table, set_list_table] = useState([])
  const [list_loading, set_list_loading] = useState(false);

  const [novoIndiceQualidade, setnovoIndiceQualidade] = useState(false);
  const [indiceQualidade_id, seIndiceQualidade_id] = useState(null);

  const GetList = () => {
    set_list_loading(true)
    api_GET(`IndiceQualidade/GetList`).then(result => {
      set_list_loading(false)
      if (result.status !== 200) {
        showMessage("Atenção", "Erro na operação.", 'error', null);
        return;
      }
      else {
        set_list_table(result.data);
      }
    });
  }

  const handleEdit = (rowData) => {
    seIndiceQualidade_id(rowData.configuracaoIndiceQualidadeId);
  }

  const handleReturn = () => {
    seIndiceQualidade_id(null);
    setnovoIndiceQualidade(false)
    GetList();
  }

  useEffect(() => {
    GetList();
  }, []);

  const columnsProp = [
    { title: 'Modalidades', field: 'modalidades' }
  ]

  return (
    <>
      <Header />
      <Container className="mt--9" fluid>
        {!novoIndiceQualidade && !indiceQualidade_id &&
          <Row>
            <Container className="mt-1" fluid>
              <Card className="shadow">
                <CardHeader className="border-0">
                  <Row>
                    <Col md="6">
                      <strong>Índice de Qualidade</strong>
                    </Col>
                    <Col md="6" className="text-right">
                      <Button color="primary" type="submit" onClick={() => setnovoIndiceQualidade(true)}>
                      <FontAwesomeIcon icon={faPlus} />  Novo
                      </Button>
                    </Col>
                  </Row>
                </CardHeader>
                <CardBody>
                  <Row>
                    <Col md="12" className="mt-1 mb-4">
                      <MaterialTable
                        title="Lista de índices Qualidade"
                        columns={columnsProp}
                        data={list_table}
                        isLoading={list_loading}
                        options={table_style}
                        actions={[
                          {
                            icon: 'edit',
                            tooltip: 'Editar Registro',
                            onClick: (event, rowData) => handleEdit(rowData)
                          }
                        ]}
                        localization={table_translate}
                      />
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Container>
          </Row>
        }
        {(novoIndiceQualidade || indiceQualidade_id != null) &&
          <IndiceQualidadeForm
            handleReturn={handleReturn}
            id={indiceQualidade_id}
          />
        }
      </Container>

    </>
  );
}
